import React from "react";
import Flexbox from "flexbox-react";
import "./GoalReportPage.css";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from "chart.js";
import { Divider } from "@blueprintjs/core";
import { getChangeIndicator } from "./getChangeIndicator";
import EmptyStateGoalChart from "./EmptyStateGoalChart";
ChartJS.register(CategoryScale, ArcElement, LinearScale, BarElement, Title, Tooltip, Legend);

const GoalOverviewProgressChart = ({ title, subtitle, goals, footerText, footerChangeText, isCycleNotStarted }) => {
  // Transform the `goals` object into chart-friendly format
  const goalEntries = Object.values(goals || {});
  const labels = goalEntries.map(item => item.label);
  const data = goalEntries.map(item => item.value);
  const colors = goalEntries.map(item => item.color);
  const legendSummary = goalEntries.map(item => ({
    label: item.label,
    color: item.color
  }));

  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderWidth: 3,
        cutout: "75%",
        spacing: "3",
        borderRadius: "4"
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true }
    }
  };
  const isAllDataZero = data.every(value => Number(value) === 0);
  return (
    <Flexbox display="flex" flexDirection="column" flexGrow={1} className="report-overview-box">
      <p className="title-text report-title">{title}</p>
      <p className="subtitle-text report-subtitle">{subtitle}</p>

      {isCycleNotStarted || isAllDataZero ? (
         <EmptyStateGoalChart 
         message={!isCycleNotStarted && isAllDataZero ? "Employees have not done any activity" : undefined} 
         subtext={!isCycleNotStarted && isAllDataZero ? "Charts will appear here once the Employees starts" : undefined}
       />
      ) : (
        <>
          <div style={{ height: "200px", margin: "20px 0" }}>
            <Doughnut data={chartData} options={options} />
          </div>

          <Flexbox display="flex" justifyContent="center" className="legend-box">
            {legendSummary.map(({ color, label }, index) => (
              <LegendItem key={index} color={color} label={label} />
            ))}
          </Flexbox>
          
          <Divider className="divider-line" />

          <Flexbox display="flex" justifyContent="space-between">
            <span className="subtitle-text grey-text">{footerText}</span>
            <span className="small-text" style={{}}>
              {getChangeIndicator(footerChangeText)}
            </span>
          </Flexbox>
        </>
      )}
    </Flexbox>
  );
};

const LegendItem = ({ color, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "6px" }}>
    <span
      style={{
        width: 14,
        height: 14,
        backgroundColor: color,
        borderRadius: "25%"
      }}
    ></span>
    <span className="title-text grey-text" style={{ fontSize: "15px" }}>
      {label}
    </span>
  </div>
);
export default GoalOverviewProgressChart;
